module.exports = __webpack_public_path__ + "img/medcube_1.cb8f9281.jpg";